import { Component, OnInit, Inject, Optional } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { EventsService } from '../crud-service'
import { S3_URL_BASE } from 'src/environments/environment'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-meeting-event',
  templateUrl: './meeting-event.component.html',
  styleUrls: ['./meeting-event.component.sass']
})
export class MeetingEventComponent implements OnInit {
  meetingData: any = null
  eventId: string | null = null
  isLoading: boolean = true
  errorMessage: string | null = null

  // Recebe data opcionalmente, caso abra como modal
  constructor(
    private route: ActivatedRoute,
    private eventsService: EventsService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef?: MatDialogRef<MeetingEventComponent>,
  ) { }

  ngOnInit(): void {
    // 1) Tentar pegar eventId via rota
    this.route.paramMap.subscribe(params => {
      const routeEventId = params.get('eventId')

      if (routeEventId) {
        // Se veio pela rota, usa esse ID
        this.fetchMeetingData(routeEventId)
      } else {
        // Se NÃO veio pela rota, tentar pegar do data do modal
        this.checkModalData()
      }
    })
  }

  private checkModalData(): void {
    if (this.data?.element?.id) {
      // Se abriu via modal e o ID do evento está em this.data.element.id
      this.fetchMeetingData(this.data.element.id)
    } else {
      // Nem rota, nem data -> erro
      this.errorMessage = 'ID do evento não encontrado.'
      this.isLoading = false
    }
  }

  private fetchMeetingData(eventId: string): void {
    this.isLoading = true
    this.eventsService.getMeetingFromEvent(eventId).subscribe({
      next: (meeting) => {
        this.loadMeetingData(meeting)
        this.isLoading = false
      },
      error: (err) => {
        console.error('Erro ao buscar reunião:', err)
        this.errorMessage = 'Erro ao carregar a reunião.'
        this.isLoading = false
      }
    })
  }

  private loadMeetingData(meeting: any): void {
    const datePipe = new DatePipe('pt-BR')
    let partners = []
    if (meeting.partner) {
      partners = [{
        name: meeting.partner.name || 'Sem nome',
        image: meeting.partner.image
          ? this.getUrl(meeting.partner.image)
          : 'assets/img/partner-placeholder.png'
      }]
    } else if (meeting.partners && typeof meeting.partners === 'string' && meeting.partners.trim() !== '') {
      partners = meeting.partners.split(',').map((name: string) => ({
        name: name.trim(),
        image: 'assets/img/partner-placeholder.png'
      }))
    } else {
      partners = [{ name: 'Sem parceiros', image: 'assets/img/partner-placeholder.png' }]
    }

    this.meetingData = {
      meetingDateTime: meeting.meetingDateTime
        ? datePipe.transform(meeting.meetingDateTime, 'dd/MM/yyyy HH:mm')
        : 'Não informado',
      linkMeeting: meeting.linkMeeting?.startsWith('http')
        ? meeting.linkMeeting
        : `https://${meeting.linkMeeting}`,
      systemImage: meeting.system?.image
        ? this.getUrl(meeting.system.image)
        : 'assets/img/system-placeholder.png',
      description: meeting.eventForm?.description || 'Sem descrição',
      image: meeting.eventForm?.image || 'assets/img/meeting-placeholder.png',
      system: meeting.system ? meeting.system.name : 'Não informado',
      partners: partners
    }
  }

  public getUrl(value: string) {
    if (!value) {
      return 'assets/img/wazir/wazir-icon.svg'
    }
    return `${S3_URL_BASE}${value}`
  }

  public get partnerNames(): string {
    if (this.meetingData && this.meetingData.partners && this.meetingData.partners.length) {
      return this.meetingData.partners.map((p: any) => p.name).join(', ')
    }
    return ''
  }
}
